var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.88,
    cy: 287.88,
    r: 287.88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1002_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 161,
    width: 318,
    height: 252
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.947 185.313C168.947 179.07 171.453 173.082 175.914 168.667C180.375 164.252 186.425 161.772 192.734 161.772C199.042 161.772 205.092 164.252 209.553 168.667C214.014 173.082 216.52 179.07 216.52 185.313C216.52 191.557 214.014 197.545 209.553 201.96C205.092 206.375 199.042 208.855 192.734 208.855C186.425 208.855 180.375 206.375 175.914 201.96C171.453 197.545 168.947 191.557 168.947 185.313ZM200.662 280.313V312.241L225.936 337.254C229.454 340.736 231.783 345.199 232.576 350.055L240.109 394.636C241.546 403.17 235.698 411.263 227.076 412.685C218.453 414.107 210.276 408.32 208.839 399.786L201.753 357.657L162.405 318.715C156.459 312.83 153.089 304.835 153.089 296.498V253.289C153.089 237.399 166.073 224.549 182.129 224.549C194.072 224.549 205.172 230.435 211.812 240.244L235.302 275.114L240.307 277.567V240.244C240.307 231.563 247.393 224.549 256.165 224.549H319.596C328.367 224.549 335.454 231.563 335.454 240.244V277.616L340.459 275.163L363.948 240.244C370.539 230.435 381.689 224.549 393.632 224.549C409.688 224.549 422.672 237.399 422.672 253.289V296.498C422.672 304.835 419.351 312.83 413.405 318.715L374.057 357.657L366.971 399.786C365.534 408.32 357.357 414.107 348.735 412.685C340.112 411.263 334.264 403.17 335.701 394.636L343.234 350.055C344.027 345.199 346.356 340.736 349.874 337.254L375.148 312.241V280.313L365.732 294.291C363.453 297.724 360.281 300.47 356.564 302.285L327.029 316.9C325.84 317.538 324.601 317.979 323.263 318.274C321.975 318.568 320.637 318.715 319.348 318.666H256.512C255.273 318.715 254.034 318.568 252.795 318.323C251.358 318.029 250.02 317.538 248.781 316.851L219.295 302.236C215.579 300.421 212.457 297.626 210.128 294.242L200.712 280.264L200.662 280.313ZM130.442 391.35L154.13 332.742L178.511 356.872L159.878 402.974C156.607 411.017 147.39 414.941 139.263 411.704C131.136 408.467 127.171 399.394 130.442 391.35ZM383.027 161.772C389.336 161.772 395.386 164.252 399.847 168.667C404.308 173.082 406.814 179.07 406.814 185.313C406.814 191.557 404.308 197.545 399.847 201.96C395.386 206.375 389.336 208.855 383.027 208.855C376.718 208.855 370.668 206.375 366.207 201.96C361.746 197.545 359.24 191.557 359.24 185.313C359.24 179.07 361.746 173.082 366.207 168.667C370.668 164.252 376.718 161.772 383.027 161.772ZM421.631 332.742L445.318 391.35C448.589 399.394 444.625 408.516 436.498 411.753C428.37 414.99 419.153 411.066 415.882 403.023L397.25 356.921L421.631 332.791V332.742Z",
    fill: "#DCCCC9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1002_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.87891,
    y: -53.1191,
    width: 639.191,
    height: 700.208,
    fill: "#FA0073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.156,
    height: 251.109,
    fill: "white",
    transform: "translate(129.303 161.772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlv);
export default __webpack_public_path__ + "static/media/dlv.2fb5fb2fec4ca4ec2617fd5dbe174ebe.svg";
export { ForwardRef as ReactComponent };